import { useCallback, useEffect, useState } from 'react'

import { UIVersion } from '../../types'
import {
  listStudentUIRolloutProfiles,
  UIRolloutProfile,
  updateStudentUIVersion,
} from '../services/uiVersionRepository'

export const useUIRolloutProfiles = (administratorId?: string) => {
  const [profiles, setProfiles] = useState<UIRolloutProfile[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [updatingId, setUpdatingId] = useState<string | null>(null)

  const loadProfiles = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      setProfiles(await listStudentUIRolloutProfiles())
    } catch {
      setError('No pudimos cargar los perfiles. Inténtalo nuevamente.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadProfiles()
  }, [loadProfiles])

  const changeVersion = async (studentId: string, uiVersion: UIVersion) => {
    if (!administratorId) {
      setError('No pudimos identificar a la persona administradora.')
      return
    }

    setUpdatingId(studentId)
    setError(null)

    try {
      await updateStudentUIVersion({
        administratorId,
        studentId,
        uiVersion,
      })
      setProfiles((currentProfiles) =>
        currentProfiles.map((profile) =>
          profile.uid === studentId ? { ...profile, uiVersion } : profile,
        ),
      )
    } catch {
      setError('No pudimos guardar el cambio. Verifica tus permisos.')
    } finally {
      setUpdatingId(null)
    }
  }

  return {
    profiles,
    loading,
    error,
    updatingId,
    reload: loadProfiles,
    changeVersion,
  }
}
